module.exports = __webpack_public_path__ + "img/honor5.a58fa186.jpg";